
import React from "react";
import axios, { AxiosResponse } from "axios";
import { useHistory } from "react-router-dom";
import { cookieKeys, getCookie } from "./Cookies";
import { cookieObj } from "../models/cookieObj";
import { logUserActivity, logBeforeLoginActivity } from "../services/FunctionServices";
function getHeaders(token) {
  // ////console.log(token);
  return {
    Authorization: `Bearer ${token}`,
  };
}

export const getRequest = async (url, defaultObje) => {

  const token = getCookie("token");

  if (token == undefined || token == null) {
    return await axios.get(url);
  } else {
    const options = {
      headers: getHeaders(token),
    };
    // return await axios.get(url, options);
    let response = []
    response = axios.get(url, options)
      .then(response => response)
      .catch((error) => {
        if (error.response.status === 401) {
          cookieKeys(cookieObj, 0);
          window.location.href = "/sign-in";
        }
        return Promise.reject(error);
      });
    return response;
  }
};

export const postRequest = (url, data,isBlob=false) => {
  ////
  const token = getCookie("token");
  if (token == undefined || token == null) {
    return axios.post(url, data);
  } else {
    const options = {
      headers: getHeaders(token),
    };
    if(isBlob)
      options.responseType="blob";
    // return axios.post(url, data, options);
    let response = []
    response = axios.post(url, data, options)
      .then(response => response)
      .catch((error) => {
        if (error.response.status === 401) {

          cookieKeys(cookieObj, 0);
          if (window.location.href.indexOf('sign-in') > -1) {
            logBeforeLoginActivity("Login Failed", JSON.parse(error.response.config.data).username);
          }
          //window.location.href = "/sign-in";

        }
        return Promise.reject(error);
      });
    return response;
  }
};

export const putRequest = (url, data, callback) => {
  ////
  const token = getCookie("token");
  if (token == undefined || token == null) {
    return axios.put(url, data);
  } else {
    const options = {
      headers: getHeaders(token)//,
    //  "Content-Type": typeof (data) == "string" ? "text/html":"application/json",
    };
    let response = []
    response = axios.put(url, data, options)
      .then(response => response)
      .catch((error) => {
        if (error.response.status === 401) {
          cookieKeys(cookieObj, 0);
          window.location.href = "/sign-in";
        }
        return Promise.reject(error);
      });
    return response;
    // let response =[]
    //  response =  axios.put(url, data, options)
    // .then(response=>{if(typeof callback!="undefined")callback(response);})
    // .catch(error=>{if(error.response.status ===401){
    // cookieKeys(cookieObj, 0);
    // window.location.href = "/sign-in";
    // }if(typeof callback!="undefined")callback(error.response);});
    // return response;
  }
};

export const deleteRequest = (url) => {
  ////
  const token = getCookie("token");

  if (token == undefined || token == null) {
    return axios.delete(url);
  } else {
    const options = {
      headers: getHeaders(token),
    };
    // return axios.delete(url, options);
    let response = []
    response = axios.delete(url, options)
      .then(response => response)
      .catch((error) => {
        if (error.response.status === 401) {
          cookieKeys(cookieObj, 0);
          window.location.href = "/sign-in";
        }
        return Promise.reject(error);
      });
    return response;
  }
};


// export  { GetRequest, PostRequest, PutRequest, DeleteRequest };
